import { render, staticRenderFns } from "./messagingInbox.vue?vue&type=template&id=e10ed608&"
import script from "./messagingInbox.vue?vue&type=script&lang=ts&"
export * from "./messagingInbox.vue?vue&type=script&lang=ts&"
import style0 from "./messagingInbox.vue?vue&type=style&index=0&id=e10ed608&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports